// Generated by BUCKLESCRIPT VERSION 2.1.0, PLEASE EDIT WITH CARE
'use strict';

var Cn          = require("re-classnames/lib/js/src/Cn.bs.js");
var Curry       = require("bs-platform/lib/js/curry.js");
var React       = require("react");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");

((require('./Card.css')));

var component = ReasonReact.statelessComponent("Card");

function make(data, $staropt$star, onClick, _) {
  var isSelected = $staropt$star ? $staropt$star[0] : /* false */0;
  var newrecord = component.slice();
  newrecord[/* render */9] = (function () {
      return React.createElement("div", {
                  className: Cn.make(/* :: */[
                        "Card",
                        /* :: */[
                          Cn.ifBool(isSelected, "isSelected"),
                          /* :: */[
                            Cn.ifBool(data[/* isGuesed */2], "isGuesed"),
                            /* [] */0
                          ]
                        ]
                      ]),
                  onClick: (function () {
                      var match = isSelected || data[/* isGuesed */2];
                      if (match !== 0) {
                        return /* () */0;
                      } else {
                        return Curry._1(onClick, /* () */0);
                      }
                    })
                }, React.createElement("div", {
                      className: "Card-flipper"
                    }, React.createElement("div", {
                          className: "Card-front card notification is-primary"
                        }, React.createElement("span", {
                              className: "icon"
                            }, React.createElement("i", {
                                  className: "fas fa-retweet fa-2x"
                                }))), React.createElement("div", {
                          className: "Card-back card"
                        }, React.createElement("img", {
                              src: data[/* url */3]
                            }))));
    });
  return newrecord;
}

exports.component = component;
exports.make      = make;
/*  Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/Card.re
// module id = 30
// module chunks = 0